<template>
    <div class="document-category-container">
        <img class="base-banner" :src="banner" />
        <div class="panel-wrapper">
            <h4>资料下载</h4>
            <div class="panel-content">
                <router-link
                    class="panel"
                    v-for="item in list"
                    :key="item.id"
                    :to="{ name: 'pdfList', params: { hId: item.id } }"
                    :style="{ backgroundImage: `url('${item.detail.img}')` }"
                >
                    <div class="cover">
                        <div class="title">{{ item.name }}</div>
                        <img class="arrow" src="@/assets/imgs/arrow-w.png" />
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs'
import { getDataHierarchies, getDataModule } from '@custouch/proxy-use'
export default {
    props: ['mId'],
    data() {
        return {
            list: [],
            banner: ''
        }
    },
    async created() {
        this.list = await getDataHierarchies(this.mId)
        this.banner = (await getDataModule({
            dataModuleId: window.env.CMS.module.doc
        })).image
        anime({
            targets: '.panel',
            opacity: [0, 1],
            translateY: ['200%', 0],
            duration: 750,
            easing: 'spring(1, 80, 10, 0)',
            delay: anime.stagger(100, { start: 300 })
        })
    }
}
</script>

<style scoped lang="less">
.panel-wrapper {
    padding: 1rem;
    line-height: 1;
}
.panel-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.panel {
    width: 8rem;
    height: 4.5rem;
    opacity:0;
    margin-bottom: 0.75rem;
    background: no-repeat center/cover;
    .cover {
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
        padding: 0.4rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #fff;
    }
    .arrow {
        align-self: flex-end;
        width: 0.6rem;
        object-fit: contain;
    }
    .title {
        font-weight: bold;
    }
}
</style>
